import daysjs from 'dayjs';

/**
 * Check if i need to put show Session Error
 * @param {Date} expirationDate
 * @param {string} status
 * @param {Session} session
 */
export function checkIfSessionCouldBeStarted(session, expirationDate, status = 'invited') {
	// !requisite
	if (
		status !== 'finished' &&
		status !== 'survey' &&
		daysjs().unix() > session?.endDate &&
		daysjs().unix() > expirationDate
	) {
		// eslint-disable-next-line no-throw-literal
		throw { status: 403, message: 'SESSION_ENDED' };
	}
	// !started
	if (
		status !== 'started' &&
		status !== 'finished' &&
		status !== 'survey' &&
		session?.timeToAccess &&
		daysjs().unix() < session?.endDate &&
		daysjs().unix() > session?.startDate + session?.timeToAccess * 60
	) {
		// eslint-disable-next-line no-throw-literal
		throw { status: 403, message: 'SESSION_LOCKED' };
	}
}
